import { WasteEntryDto, CreateWasteEntryDto, ChangeWasteEntryContainerDto } from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase, axios } from './api'

export type WasteEntrySource = 'PREPARATION' | 'ELUTION' | 'MANUAL'

export type WasteEntriesFilters = PaginatedQueryBase & {
  containerId?: string
  from?: string
  to?: string
  source?: WasteEntrySource
  sourceNo?: number
  no?: number
}

class WasteEntryService extends BaseCrudService<
  WasteEntryDto,
  CreateWasteEntryDto,
  never,
  WasteEntriesFilters
> {
  constructor() {
    super('waste-entry', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }

  cancel(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('delete', `${this.endpoint}/${id}`)
      axios(configs, resolve, reject)
    })
  }

  changeContainer(id: string, dto: ChangeWasteEntryContainerDto): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/change-container`, dto)
      axios(configs, resolve, reject)
    })
  }
}

export const wasteEntryService = new WasteEntryService()
